export const parseItems = (items: any, type?: string) => {
  const arr = [...items];
  let newArray: any = [];
  newArray = arr.filter((item: { idNomeCampo: string }) => !!item.idNomeCampo);
  if (type === "onlyChecked") {
    newArray = newArray.filter(
      (item: { selecionado: boolean }) => item.selecionado
    );
  }
  let result: any = [];
  result = newArray.map((item) => {
    return {
      key: item.idNomeCampo,
      label: item.descricao,
      checked: item.selecionado,
      encrypted: item.idNomeCampo === "gerenteRegional" ? true : false,
    };
  });
  return result;
};

interface IUserSetupState {
  userConfig: {
    views: {
      configuracoes: {
        camposDaMatriz: {
          camposLista: any;
          tipoCampos: any;
          camposExportacao: any;
        };
      };
    };
  };
}

interface IUserSetupPayload {
  payload: { items: any; tipoCampos: any };
}

export const dataUserSetupReducer = (
  state: IUserSetupState,
  action: IUserSetupPayload
) => {
  state.userConfig.views.configuracoes.camposDaMatriz.camposLista = parseItems(
    action.payload.items,
    "onlyChecked"
  );
  state.userConfig.views.configuracoes.camposDaMatriz.camposExportacao =
    parseItems(action.payload.items);
  state.userConfig.views.configuracoes.camposDaMatriz.tipoCampos = action
    .payload.tipoCampos
    ? action.payload.tipoCampos
    : "USER";
};
